import { useMemo } from 'react';

import { getTermValue } from '@/packages/JsonQuery';
import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';

export const useEarlyAccessListingUrl = (): string | null => {
  const filters = useFiltersSelector();
  const isEarlyAccessEnabled = Boolean(getTermValue('is_early_access_enabled')(filters));

  const { data: offersData } = useSearchOffersDesktopQuery();

  return useMemo(() => {
    if (isEarlyAccessEnabled || !offersData) {
      return null;
    }

    const { queryString } = offersData.pages[0].analytics.page;

    return `/cat.php?${queryString}&is_early_access_enabled=1`;
  }, [isEarlyAccessEnabled, offersData]);
};
